import React from 'react';
import { useTranslation } from 'react-i18next';
import { Mail, Shirt } from 'lucide-react';

const TshirtSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-[#eef2f7] py-20">
      <div className="page-container">
        <div className="grid overflow-hidden bg-[#172033] text-white lg:grid-cols-[0.9fr_1.1fr]">
          <div className="relative flex min-h-[420px] items-center justify-center overflow-hidden bg-[#d95f75] p-8 sm:p-12">
            <div className="absolute inset-5 border border-white/25" />
            <div className="relative flex h-72 w-64 flex-col items-center justify-center bg-[#f8f8f5] text-[#172033] shadow-2xl [clip-path:polygon(22%_0,38%_10%,62%_10%,78%_0,100%_19%,86%_34%,78%_27%,78%_100%,22%_100%,22%_27%,14%_34%,0_19%)]">
              <Shirt className="mb-4 h-7 w-7 text-[#d95f75]" />
              <p className="font-japanese text-4xl font-bold">一期一会</p>
              <p className="mt-2 text-xs font-extrabold uppercase text-[#2457a7]">Ichigo Ichie</p>
              <div className="mt-5 h-px w-20 bg-[#d95f75]" />
            </div>
          </div>

          <div className="flex flex-col justify-center p-8 sm:p-12 lg:p-16">
            <p className="eyebrow text-[#f4b7c2] before:bg-[#f4b7c2]">JAJ original</p>
            <h2 className="text-4xl font-extrabold sm:text-5xl">{t('tshirt.title')}</h2>
            <p className="mt-3 text-xl font-bold text-[#f4b7c2]">{t('tshirt.subtitle')}</p>
            <p className="mt-6 max-w-xl leading-7 text-white/70">{t('tshirt.meaning')}</p>

            <div className="mt-8 grid grid-cols-2 border-y border-white/15 py-5 text-sm">
              <div>
                <p className="text-xs font-bold uppercase text-white/45">Sizes</p>
                <p className="mt-2 font-semibold">{t('tshirt.sizes')}</p>
              </div>
              <div className="border-l border-white/15 pl-5">
                <p className="text-xs font-bold uppercase text-white/45">Extended</p>
                <p className="mt-2 font-semibold">{t('tshirt.size2xl')}</p>
              </div>
            </div>

            <a href="mailto:jaxjapanese@gmail.com?subject=JAJ%20T-Shirt%20Order" className="btn-primary mt-8 w-full bg-white text-[#172033] hover:bg-[#f4d5da] sm:w-auto">
              <Mail className="h-4 w-4" />
              Order by Email
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TshirtSection;
